import { mapActions, mapState, mapGetters } from 'vuex';
import searchBar from '@/components/app/app-header/search-bar/search-bar.vue';
import headerNavMixin from '@/mixins/headerNav';
import loaderMixin from '@/mixins/loader';
import accountVerifyMixin from '@/mixins/accountVerify';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  mixins: [
    headerNavMixin,
    loaderMixin,
    accountVerifyMixin
  ],
  components: {
    searchBar,
  },
  computed: {
    ...mapState('app', ['mobileMenuOpened']),
    ...mapGetters('app', ['leaderboardsEnabled']),
    enabledLinks() {
      return this.links.filter(i => i.enabled);
    },
    links() {
      if (this.isLoggedIn) {
        return [
          {
            title: 'Markets',
            name: 'markets',
            href: '/markets',
            nested: false,
            enabled: true,
          },
          {
            title: 'News',
            name: 'news',
            href: '/news',
            nested: false,
            enabled: true,
          },
          {
            title: 'Trends',
            name: 'trends',
            href: '/trends',
            nested: false,
            enabled: false
          },
          {
            title: 'Dashboard',
            name: 'dashboard',
            href: '/dashboard',
            nested: false,
            enabled: true,
          },
          {
            title: 'Leaderboards',
            name: 'leaderboards',
            href: '/leaderboards',
            enabled: this.leaderboardsEnabled,
            nested: false,
          },
          {
            title: 'Account',
            name: 'account',
            href: '/account',
            nested: false,
            enabled: true,
          },
          {
            title: 'Learn',
            name: 'help',
            href: '/support',
            nested: true,
            enabled: true,
          },
          {
            title: 'Wallet',
            name: 'wallet',
            href: '/account/wallet',
            nested: true,
            enabled: this.isUserVerified,
          },
        ];
      }

      return [
        {
          title: 'Markets',
          name: 'markets',
          href: '/markets',
          nested: false,
          enabled: true,
        },
        {
          title: 'News',
          name: 'news',
          href: '/news',
          nested: false,
          enabled: true,
        },
        {
          title: 'Learn',
          name: 'help',
          href: '/support',
          nested: false,
          enabled: true,
        },
        {
          title: 'Insights',
          name: 'insight',
          href: '/insight',
          nested: false,
          enabled: false
        },
        {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          enabled: this.leaderboardsEnabled,
          nested: false,
        },
      ];
    },
  },
  watch: {
    mobileMenuOpened(value) {
      const action = value ? 'add' : 'remove';
      document.documentElement.classList[action]('modal-open');
      document.body.classList[action]('modal-open');
    },
  },
  methods: {
    ...mapActions('app', ['closeMobileMenu']),
    ...mapActions('user', ['logout']),
    ...mapActions('popup', ['setCurrentPopup']),
    onLinkClick(href) {
      if (this.$route && this.$route.path === href && this.mobileMenuOpened) {
        window.scrollTo(0, 0);
        this.closeMobileMenu();
      }
    },
    itemClassModifiers(item) {
      return {
        'app-mobile-menu__nav-item': true,
        'app-mobile-menu__nav-item--nested': item.nested,
        'app-mobile-menu__nav-item--active': this.$route.path.includes(item.href),
      };
    },
    itemIconClassModifiers(item) {
      return {
        'app-mobile-menu__nav-item-icon': true,
        [`app-mobile-menu__nav-item-icon--${item.name}`]: item.name,
      };
    },
    logoutButton() {
      this.loaderAdd(document.body);
      this.logout();
      this.$gtm.trackEvent({ event: 'Logout' });
    },
    showLeavingPopup() {
      if (this.mobileMenuOpened) {
        window.scrollTo(0, 0);
        this.closeMobileMenu();
      }
      this.setCurrentPopup(MODALS.LEAVING_POPUP);
    },
  },
  beforeDestroy() {
    document.documentElement.classList.remove('modal-open');
    document.body.classList.remove('modal-open');
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-mobile-menu/app-mobile-menu.js